import {Icon} from '@/app/components/Icon';
import {cn} from '@/lib/utils';
import {Button} from '@/components/app/button';
import {Notice} from '@/components/app/feedback';
import {useAppDispatch} from '../../../app/hooks/useAppDispatch';
import {useAppSelector} from '../../../app/hooks/useAppSelector';
import {hidePageMessage, selectPageMessages} from '../coreSlice';
export const PageMessages = () => {
  const dispatch = useAppDispatch();
  const pageMessages = useAppSelector(selectPageMessages);
  return (
    <>
      {pageMessages.map((pageMessage) => {
        const id = pageMessage.id;
        return (
          <Notice
            className="py-2 z-1 relative justify-center text-center"
            tone={pageMessage.severity}
            content={
              <>
                {pageMessage.content}
                {pageMessage.dismissable && id != null && (
                  <Button
                    className={cn(
                      'text-muted-foreground absolute right-0 top-1/2 -translate-y-1/2 mr-2',
                      'rounded-full',
                    )}
                    onClick={() =>
                      dispatch(
                        hidePageMessage({
                          id,
                        }),
                      )
                    }
                    size="sm"
                    variant="ghost"
                    type="button"
                    startIcon={<Icon icon={'times'} />}
                    aria-label={'Close'}
                  />
                )}
              </>
            }
            key={pageMessage.id}
          />
        );
      })}
    </>
  );
};
